import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/achat/reception`;

export const createBonReception = (data) => axios.post(`${API_BASE_URL}/create`, data);
export const saveBonReception = (payload) => axios.put(`${API_BASE_URL}/save`, payload);
export const getBonReception = (id) => axios.get(`${API_BASE_URL}/get/${id}`);
export const listBonReceptions = (params) => axios.get(`${API_BASE_URL}/list`, { params });
export const getItemsInBonReception = (id) => axios.get(`${API_BASE_URL}/items/${id}`);
export const validateBonReception = (id) => axios.post(`${API_BASE_URL}/validate/${id}`);
export const unvalidateBonReception = (id) => axios.post(`${API_BASE_URL}/unvalidate/${id}`);
export const transferReceptionToFacture = (id) => axios.post(`${API_BASE_URL}/transfer-to-facture/${id}`);
export const listDBFFiles = () => axios.get(`${API_BASE_URL}/dbf/list`);
export const importFromDBF = (fileName) => axios.post(`${API_BASE_URL}/dbf/import`, { fileName });

// Seed DBF upload APIs
export const uploadBonReceptionDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-bonreception`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const uploadBonReceptionDetailsDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-details`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const uploadBothBonReceptionDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-both`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
